<template>
  <div class="repitemtitle">
    <CardSymbols
      v-if="item.flopGroup === 'swv_flops' || item.flopGroup === 'swv_turns'"
      :colorDefault="colorDefault"
      :cardsIds="item.id"
      style="--size: var(--font-size)"
    />
    <div
      v-else
      class="f-center"
    >
      <div
        v-if="flopGroup === 'swv_suits'"
        class="d-flex mr-1"
      >
        <div
          v-for="(letter, idx) in suitsSymbols[item.id] ? suitsSymbols[item.id] : [item.id[0]]"
          :key="`${letter}_${idx}`"
          class="mdi text-semi-large"
          :class="suitsConf[letter].icon"
          :style="`color:var(${suitsConf[letter][colorDefault ? 'colorDefault' : 'color']})`"
        ></div>
      </div>
      {{ $t(`practice.filter.${item.id}`) }}
    </div>
  </div>
</template>

<script>
import CardSymbols from '@/components/CardSymbols/CardSymbols'
import { getSuitsSymbols, getSuitsConf } from '@/helpers/constants'

export default {
  name: 'StudyReportsGroupItemTitle',
  components: {
    CardSymbols,
  },
  props: {
    item: Object,
    colorDefault: { default: () => false },
    flopGroup: String,
  },
  data() {
    this.suitsSymbols = getSuitsSymbols()
    this.suitsConf = getSuitsConf()
    return {}
  },
}
</script>
<style lang="scss" scoped>
.repitemtitle {
  --font-size: 1rem;
  // --font-size: 1.125rem;
  font-size: var(--font-size);
  line-height: 1;
  min-width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
